import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, NavigationLeftIcon, PayPalIcon, Text, useResponsive } from '@common-fe/common-fe';

import { ModalWrapper } from '@/components/wrappers';
import { DuplicationErrorModal } from '@/modules/transaction/components/ReimburseMe/ConfirmationStep/Immediately/DublicationErrorModal/DuplicationErrorModal';
import theme from '@/styles/theme';

import { BackIcon } from '../DirectDeposit/StyledComponents.styles';

import { AddPayPalForm } from './AddPayPalForm';

const DESCRIPTION = 'Enter your email or mobile number associated with your PayPal account to get started.';

interface Props {
  onClose: () => void;
  onBack: () => void;
  onSuccess: () => void;
  hideNavigationButton?: boolean;
  allowSaveAsDefault?: boolean;
}

export const AddPayPalAccountModal: React.FC<Props> = ({
  onClose,
  onBack,
  onSuccess,
  hideNavigationButton,
  allowSaveAsDefault,
}) => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  const [serverErrorShow, setServerErrorShow] = useState(false);

  return (
    <ModalWrapper
      visible
      contentStyle={{
        padding: isMobile ? `${theme.spacings.spacing24} ${theme.spacings.spacing16}` : undefined,
      }}
      onSetVisible={onClose}
      testId="AddPayPalAccountModal_testId"
    >
      {onBack && !hideNavigationButton && !isMobile && (
        <BackIcon onClick={onBack} data-testid="back-icon-button">
          <NavigationLeftIcon color="iconPrimary" size="18px" />
        </BackIcon>
      )}

      <Box align="center">
        <Box width="xxsmall" alignSelf="center" data-testid="PayPal_icon">
          <PayPalIcon />
        </Box>

        <Text size="2xl" textAlign="center" weight="bold" color="textBody" margin={{ top: 'spacing8' }}>
          {t('Get Reimbursed With PayPal')}
        </Text>

        <Text
          size={isMobile ? 'large' : 'medium'}
          textAlign="center"
          color="textBody"
          margin={{ top: 'spacing12', bottom: 'spacing24' }}
        >
          {t(DESCRIPTION)}
        </Text>
      </Box>

      <AddPayPalForm
        onBack={onBack}
        onSuccess={onSuccess}
        onError={() => setServerErrorShow(true)}
        allowSaveAsDefault={allowSaveAsDefault}
      />
      <DuplicationErrorModal visible={serverErrorShow} close={() => setServerErrorShow(false)} />
    </ModalWrapper>
  );
};
